module.exports = __webpack_public_path__ + "img/bind-back-3.b692b3a.png";